/**
 * Releasit COD — split quantity-offer variant selects
 *
 * Product options look like: APROVECHA ((X1)/(X2)/(X3)) / Color / Talla
 * Releasit renders one concatenated <select> per unit row.
 *
 * This module:
 *  - Hides APROVECHA visually
 *  - Builds Color + Talla selects per unit row
 *  - Locks (Xn) from the offer's unit count
 *  - Prefills from the product page selection
 *  - Keeps hidden item_variant_id / item_quantity inputs in sync
 */
(function () {
  'use strict';

  if (window.__rsiVariantSplitV2) return;
  window.__rsiVariantSplitV2 = true;

  // Disable legacy processor in releasit-setup.js if it loads
  window.__rsiDisableLegacyVariantProcessor = true;

  var STORAGE_KEY = 'selectedVariant';
  var DEBOUNCE_MS = 80;
  var QTY_RE = /^\(X\d+\)$/i;
  var HIDDEN_OPT_RE = /aprovecha|cantidad|\(x\d+\)/i;
  var mem = {};
  var scheduled = null;
  var processing = false;

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function splitParts(text) {
    return normalize(text)
      .split(/\s*\/\s*/)
      .map(function (p) {
        return p.trim();
      })
      .filter(Boolean);
  }

  function isQtyPart(part) {
    return QTY_RE.test(normalize(part));
  }

  function isHiddenOptionName(name) {
    return HIDDEN_OPT_RE.test(String(name || ''));
  }

  function storageGet() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) { /* ignore */ }
    return mem[STORAGE_KEY] || null;
  }

  function storageSet(data) {
    var payload = Object.assign({}, data || {}, { timestamp: Date.now() });
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      mem[STORAGE_KEY] = payload;
    }
    return payload;
  }

  function ensureStyles() {
    if (document.getElementById('rsi-variant-split-styles')) return;
    var style = document.createElement('style');
    style.id = 'rsi-variant-split-styles';
    style.textContent = [
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-title.custom-offer-title{display:none!important}',
      '#_rsi-cod-form-modal-form .rsi-unit-row{width:100%;display:flex;flex-direction:column;gap:8px;margin:0 0 10px;padding:0;box-sizing:border-box}',
      '#_rsi-cod-form-modal-form .rsi-unit-row:last-child{margin-bottom:0}',
      '#_rsi-cod-form-modal-form .rsi-unit-row__label{font-family:"Poppins Bold",sans-serif;font-size:13px;font-weight:700;line-height:1.2;margin:0}',
      '#_rsi-cod-form-modal-form .rsi-unit-row__fields{display:flex;flex-wrap:wrap;gap:8px;width:100%}',
      '#_rsi-cod-form-modal-form .rsi-variant-group{flex:1 1 140px;min-width:0;display:flex;flex-direction:column;gap:4px}',
      '#_rsi-cod-form-modal-form .rsi-variant-label{font-size:12px;font-weight:700;text-transform:uppercase;line-height:1.2;opacity:.85}',
      '#_rsi-cod-form-modal-form .rsi-variant-select{width:100%;min-width:0;height:44px;border-radius:12px;border:2px solid rgba(0,0,0,.18)!important;padding:8px 36px 8px 12px;font-size:14px;font-weight:600;appearance:none;-webkit-appearance:none;background-color:#fff!important;background-image:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBvbHlsaW5lIHBvaW50cz0iNiA5IDEyIDE1IDE4IDkiLz48L3N2Zz4=");background-repeat:no-repeat;background-position:right 10px center;background-size:16px;box-sizing:border-box;color:#333!important;-webkit-text-fill-color:#333!important;box-shadow:none!important}',
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container ._rsi-modal-fields-item.has-content.completed .rsi-variant-select,#_rsi-cod-form-modal-form ._rsi-quantity-offers-variant-selector.has-content.completed .rsi-variant-select,#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container ._rsi-modal-fields-item.has-content.completed select.rsi-variant-select:not(:focus){background-color:#fff!important;background-image:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBvbHlsaW5lIHBvaW50cz0iNiA5IDEyIDE1IDE4IDkiLz48L3N2Zz4=")!important;background-repeat:no-repeat!important;background-position:right 10px center!important;background-size:16px!important;color:#333!important;-webkit-text-fill-color:#333!important;border:2px solid rgba(0,0,0,.18)!important;box-shadow:none!important}',
      '#_rsi-cod-form-modal-form .rsi-variant-select:focus{outline:none;border-color:#3292e1;box-shadow:0 0 0 3px rgba(50,146,225,.22);background-color:#fff!important;color:#333!important;-webkit-text-fill-color:#333!important}',
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-variant-selector select[data-offer-num][data-rsi-split="1"]{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;border:0!important}',
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-variant-number{display:none!important}',
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-variants{display:flex;flex-direction:column;width:100%;gap:8px;margin-top:8px}',
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-variant-selector.has-content.completed,#_rsi-cod-form-modal-form ._rsi-quantity-offers-variant-selector.completed{background:transparent!important;padding-right:0!important}',
      /* Accordion: only selected offer shows variant rows */
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container.has-rsi-variant-selectors:not(._rsi-quantity-offers-selected) ._rsi-quantity-offers-variants,#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container.has-rsi-variant-selectors:not(._rsi-quantity-offers-selected) > ._rsi-quantity-offers-variant-selector,#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container.has-rsi-variant-selectors:not(._rsi-quantity-offers-selected) .rsi-unit-row{display:none!important;visibility:hidden!important;height:0!important;max-height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;border:0!important;opacity:0!important;pointer-events:none!important}',
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container.has-rsi-variant-selectors._rsi-quantity-offers-selected ._rsi-quantity-offers-variants{display:flex!important;flex-direction:column!important;visibility:visible!important;height:auto!important;max-height:none!important;opacity:1!important;pointer-events:auto!important;margin-top:8px!important}',
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container.has-rsi-variant-selectors._rsi-quantity-offers-selected > ._rsi-quantity-offers-variant-selector,#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container.has-rsi-variant-selectors._rsi-quantity-offers-selected .rsi-unit-row{display:flex!important;visibility:visible!important;height:auto!important;max-height:none!important;opacity:1!important;pointer-events:auto!important}',
    ].join('');
    document.head.appendChild(style);
  }

  function readFormSelectionSeed() {
    // Prefer last values chosen inside the COD form; fall back to PDP
    var stored = storageGet() || {};
    var formOpen = !!document.querySelector(
      '#_rsi-cod-form-modal._rsi-cod-form-modal-open #_rsi-cod-form-modal-form'
    );
    if (formOpen && (stored.color || stored.size) && stored.fromForm) {
      return { color: stored.color || null, size: stored.size || null, quantity: stored.quantity || null };
    }
    return readPdpSelection({ persist: !formOpen });
  }

  function readPdpSelection(opts) {
    var persist = !opts || opts.persist !== false;
    var color = null;
    var size = null;
    var quantity = null;

    function assignByName(name, value) {
      if (!value) return;
      var n = String(name || '').toLowerCase();
      var v = normalize(value);
      if (isHiddenOptionName(n) || isQtyPart(v)) {
        quantity = v;
      } else if (/color/i.test(n)) {
        color = v;
      } else if (/talla|size|tama[nñ]o/i.test(n)) {
        size = v;
      }
    }

    document
      .querySelectorAll('variant-selects fieldset, .product-form__input, .variant__selects-container fieldset')
      .forEach(function (fs) {
        var legend = fs.querySelector('legend, .form__label, label');
        var name = (legend && legend.textContent) || fs.getAttribute('data-option-name') || '';
        var checked = fs.querySelector('input:checked, input[aria-checked="true"]');
        if (checked) {
          assignByName(
            name,
            checked.value ||
              checked.getAttribute('data-option-value') ||
              checked.getAttribute('data-value')
          );
        }
        var sel = fs.querySelector('select');
        if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
          assignByName(name || sel.name, sel.selectedOptions[0].textContent || sel.value);
        }
      });

    document.querySelectorAll('[data-option-name]').forEach(function (el) {
      var selected =
        el.matches('input:checked') ||
        el.getAttribute('aria-checked') === 'true' ||
        el.classList.contains('selected') ||
        el.classList.contains('is-selected') ||
        el.getAttribute('aria-pressed') === 'true';
      if (!selected) return;
      assignByName(
        el.getAttribute('data-option-name'),
        el.getAttribute('data-option-value') || el.value || el.textContent
      );
    });

    if ((!color || !size) && window.meta && window.meta.product && Array.isArray(window.meta.product.variants)) {
      var idEl = document.querySelector(
        'form[action*="/cart/add"] [name="id"], product-info [name="id"], [name="id"]'
      );
      var vid = idEl && idEl.value;
      var match = window.meta.product.variants.find(function (v) {
        return String(v.id) === String(vid);
      });
      if (match && Array.isArray(match.options)) {
        match.options.forEach(function (opt, idx) {
          var optName =
            (window.meta.product.options && window.meta.product.options[idx]) || '';
          assignByName(optName, opt);
        });
      }
    }

    var stored = storageGet() || {};
    var result = {
      color: color || stored.color || null,
      size: size || stored.size || null,
      quantity: quantity || stored.quantity || null,
      fromForm: false,
    };
    if (persist) storageSet(result);
    return result;
  }

  function parseCatalog(select) {
    var rows = [];
    var qtySet = {};
    var colorSet = {};
    var sizeSet = {};

    Array.prototype.forEach.call(select.options, function (opt) {
      var parts = splitParts(opt.textContent);
      if (parts.length < 2) return;

      var qty = null;
      var color = null;
      var size = null;

      if (parts.length >= 3 && isQtyPart(parts[0])) {
        qty = parts[0];
        color = parts[1];
        size = parts[2];
      } else if (parts.length === 2) {
        color = parts[0];
        size = parts[1];
      } else {
        return;
      }

      if (qty) qtySet[qty] = true;
      if (color) colorSet[color] = true;
      if (size) sizeSet[size] = true;

      rows.push({
        id: String(opt.value),
        text: normalize(opt.textContent),
        qty: qty,
        color: color,
        size: size,
      });
    });

    return {
      rows: rows,
      qtys: Object.keys(qtySet),
      colors: Object.keys(colorSet),
      sizes: Object.keys(sizeSet),
    };
  }

  function offerQuantityKey(offer, catalog) {
    var unitCount =
      offer.querySelectorAll('._rsi-quantity-offers-variant-selector').length || 1;
    var preferred = '(X' + unitCount + ')';
    if (catalog.qtys.indexOf(preferred) !== -1) return preferred;
    var found = catalog.qtys.find(function (q) {
      return q.toUpperCase() === preferred.toUpperCase();
    });
    if (found) return found;
    return catalog.qtys[0] || null;
  }

  function findRow(catalog, qtyKey, color, size) {
    return (
      catalog.rows.find(function (row) {
        if (qtyKey && row.qty && row.qty.toUpperCase() !== String(qtyKey).toUpperCase()) {
          return false;
        }
        if (color && row.color !== color) return false;
        if (size && row.size !== size) return false;
        return true;
      }) || null
    );
  }

  function createSelect(options, selected, dataType) {
    var sel = document.createElement('select');
    sel.className = 'rsi-variant-select';
    sel.setAttribute('data-type', dataType);
    // Prevent FormProgress from painting these green as "completed"
    sel.setAttribute('data-progress-initialized', 'true');
    sel.setAttribute('data-rsi-skip-progress', '1');
    options.forEach(function (value) {
      var opt = document.createElement('option');
      opt.value = value;
      opt.textContent = value;
      if (selected && selected === value) opt.selected = true;
      sel.appendChild(opt);
    });
    if (selected && options.indexOf(selected) !== -1) sel.value = selected;
    return sel;
  }

  function syncHiddenInputs(offer, unitIndex, variantId) {
    if (!offer || !variantId) return;
    var isSelected = offer.classList.contains('_rsi-quantity-offers-selected');

    if (isSelected) {
      offer.querySelectorAll('input._rsi-quantity-offers-item-input').forEach(function (inp) {
        if (!inp.hasAttribute('data-rsi-unit-index')) inp.remove();
      });
    }

    var nameId = 'item_variant_id[qty_offer_' + unitIndex + ']';
    var nameQty = 'item_quantity[qty_offer_' + unitIndex + ']';
    var existingId = offer.querySelector(
      'input[name="' + nameId + '"][data-rsi-unit-index="' + unitIndex + '"]'
    );
    var existingQty = offer.querySelector(
      'input[name="' + nameQty + '"][data-rsi-unit-index="' + unitIndex + '"]'
    );

    if (!isSelected) {
      if (existingId) existingId.remove();
      if (existingQty) existingQty.remove();
      return;
    }

    if (existingId) {
      existingId.value = variantId;
    } else {
      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.className = '_rsi-quantity-offers-item-input';
      idInput.name = nameId;
      idInput.value = variantId;
      idInput.setAttribute('data-rsi-unit-index', String(unitIndex));
      idInput.setAttribute('data-progress-initialized', 'true');
      offer.appendChild(idInput);
    }

    if (existingQty) {
      existingQty.value = '1';
    } else {
      var qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.className = '_rsi-quantity-offers-item-input';
      qtyInput.name = nameQty;
      qtyInput.value = '1';
      qtyInput.setAttribute('data-rsi-unit-index', String(unitIndex));
      qtyInput.setAttribute('data-progress-initialized', 'true');
      offer.appendChild(qtyInput);
    }
  }

  function applyUnitSelection(unitRow, originalSelect, catalog, qtyKey, fromUser) {
    var colorSel = unitRow.querySelector('select[data-type="color"]');
    var sizeSel = unitRow.querySelector('select[data-type="size"]');
    if (!colorSel || !sizeSel) return null;

    var row =
      findRow(catalog, qtyKey, colorSel.value, sizeSel.value) ||
      findRow(catalog, null, colorSel.value, sizeSel.value);
    if (!row) return null;

    originalSelect.value = row.id;
    Array.prototype.forEach.call(originalSelect.options, function (opt) {
      opt.selected = String(opt.value) === String(row.id);
    });

    // Only notify Releasit on real user edits — soft sync must NOT cascade remounts
    if (fromUser) {
      try {
        originalSelect.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) { /* ignore */ }
    }

    var offer = originalSelect.closest('._rsi-quantity-offers-offer-container');
    var unitIndex = parseInt(unitRow.getAttribute('data-rsi-unit-index'), 10);
    if (isNaN(unitIndex)) {
      unitIndex = parseInt(originalSelect.getAttribute('data-offer-num'), 10) || 1;
    }
    var offerPos = offer ? parseInt(offer.getAttribute('data-offer-pos'), 10) || 0 : 0;
    var globalIndex = offerPos * 10 + unitIndex;
    syncHiddenInputs(offer, globalIndex, row.id);

    if (fromUser) {
      unitRow.setAttribute('data-rsi-user-set', '1');
      window.__rsiFormVariantLocked = true;
      storageSet({
        color: colorSel.value,
        size: sizeSel.value,
        quantity: qtyKey,
        fromForm: true,
      });
      if (typeof window._rsiUpdateOrderSummary === 'function') {
        clearTimeout(window.__rsiSummaryFromVariantTimer);
        window.__rsiSummaryFromVariantTimer = setTimeout(window._rsiUpdateOrderSummary, 120);
      }
    }
    return row;
  }

  function readExistingRowValues(unitRow) {
    if (!unitRow) return null;
    var colorSel = unitRow.querySelector('select[data-type="color"]');
    var sizeSel = unitRow.querySelector('select[data-type="size"]');
    if (!colorSel && !sizeSel) return null;
    return {
      color: colorSel ? colorSel.value : null,
      size: sizeSel ? sizeSel.value : null,
      userSet: unitRow.getAttribute('data-rsi-user-set') === '1',
    };
  }

  function pickPreferred(catalog, seed, existing) {
    var color = null;
    var size = null;
    // 1) Keep what the user already chose in the form
    if (existing && existing.color && catalog.colors.indexOf(existing.color) !== -1) {
      color = existing.color;
    }
    if (existing && existing.size && catalog.sizes.indexOf(existing.size) !== -1) {
      size = existing.size;
    }
    // 2) Seed from PDP / storage only when creating fresh controls
    if (!color && seed && seed.color && catalog.colors.indexOf(seed.color) !== -1) {
      color = seed.color;
    }
    if (!size && seed && seed.size && catalog.sizes.indexOf(seed.size) !== -1) {
      size = seed.size;
    }
    // 3) Catalog fallback
    if (!color) color = catalog.colors[0];
    if (!size) size = catalog.sizes[0];
    return { color: color, size: size };
  }

  function buildUnitRow(unitIndex, catalog, qtyKey, seed, originalSelect, existing) {
    var wrap = document.createElement('div');
    wrap.className = 'rsi-unit-row';
    wrap.setAttribute('data-rsi-unit-index', String(unitIndex));
    if (existing && existing.userSet) wrap.setAttribute('data-rsi-user-set', '1');

    var label = document.createElement('div');
    label.className = 'rsi-unit-row__label';
    label.textContent = unitIndex + '.';
    wrap.appendChild(label);

    var fields = document.createElement('div');
    fields.className = 'rsi-unit-row__fields';

    var preferred = pickPreferred(catalog, seed, existing);

    var colorGroup = document.createElement('div');
    colorGroup.className = 'rsi-variant-group';
    var colorLabel = document.createElement('div');
    colorLabel.className = 'rsi-variant-label';
    colorLabel.textContent = 'Color';
    var colorSel = createSelect(catalog.colors, preferred.color, 'color');
    colorGroup.appendChild(colorLabel);
    colorGroup.appendChild(colorSel);

    var sizeGroup = document.createElement('div');
    sizeGroup.className = 'rsi-variant-group';
    var sizeLabel = document.createElement('div');
    sizeLabel.className = 'rsi-variant-label';
    sizeLabel.textContent = 'Talla';
    var sizeSel = createSelect(catalog.sizes, preferred.size, 'size');
    sizeGroup.appendChild(sizeLabel);
    sizeGroup.appendChild(sizeSel);

    fields.appendChild(colorGroup);
    fields.appendChild(sizeGroup);
    wrap.appendChild(fields);

    var onChange = debounce(function () {
      applyUnitSelection(wrap, originalSelect, catalog, qtyKey, true);
    }, DEBOUNCE_MS);

    colorSel.addEventListener('change', onChange);
    sizeSel.addEventListener('change', onChange);

    return wrap;
  }

  function syncExistingSelector(variantSelector, offer) {
    var originalSelect = variantSelector.querySelector('select[data-offer-num]');
    var existingRow = variantSelector.querySelector('.rsi-unit-row');
    if (!originalSelect || !existingRow) return false;
    var catalog = parseCatalog(originalSelect);
    if (!catalog.colors.length || !catalog.sizes.length) return false;
    var qtyKey = offerQuantityKey(offer, catalog);
    // Never overwrite Color/Talla UI — only push current values into hidden inputs
    applyUnitSelection(existingRow, originalSelect, catalog, qtyKey, false);
    return true;
  }

  function transformSelector(variantSelector, offer, seed, forceRefresh) {
    var originalSelect = variantSelector.querySelector('select[data-offer-num]');
    if (!originalSelect) return;

    var existingRow = variantSelector.querySelector('.rsi-unit-row');
    var alreadySplit = originalSelect.getAttribute('data-rsi-split') === '1';
    var userLocked =
      (existingRow && existingRow.getAttribute('data-rsi-user-set') === '1') ||
      !!window.__rsiFormVariantLocked;

    // Soft pass OR user already edited: keep UI, only sync hidden inputs
    if (alreadySplit && existingRow && (!forceRefresh || userLocked)) {
      syncExistingSelector(variantSelector, offer);
      return;
    }

    // Preserve values across rebuilds (Buy Now / remount)
    var preserved = readExistingRowValues(existingRow);

    if (forceRefresh) {
      originalSelect.removeAttribute('data-rsi-split');
      variantSelector.querySelectorAll('.rsi-unit-row').forEach(function (n) {
        n.remove();
      });
    }

    if (originalSelect.getAttribute('data-rsi-split') === '1') {
      syncExistingSelector(variantSelector, offer);
      return;
    }

    var catalog = parseCatalog(originalSelect);
    if (!catalog.colors.length || !catalog.sizes.length) return;

    var qtyKey = offerQuantityKey(offer, catalog);
    var unitIndex = parseInt(originalSelect.getAttribute('data-offer-num'), 10) || 1;

    variantSelector
      .querySelectorAll('.rsi-unit-row, .variants-container, .multiple-fajas-container')
      .forEach(function (n) {
        n.remove();
      });

    // Prefer preserved form values over PDP seed
    var unitRow = buildUnitRow(unitIndex, catalog, qtyKey, seed, originalSelect, preserved);
    originalSelect.setAttribute('data-rsi-split', '1');
    originalSelect.setAttribute('data-rsi-skip-progress', '1');
    originalSelect.setAttribute('data-progress-initialized', 'true');
    variantSelector.insertBefore(unitRow, originalSelect);

    var number = variantSelector.querySelector('._rsi-quantity-offers-variant-number');
    if (number) number.style.display = 'none';

    variantSelector.classList.remove(
      'has-content',
      'completed',
      'is-next-active',
      'is-next-two',
      '_rsi-modal-fields-item-error'
    );

    applyUnitSelection(unitRow, originalSelect, catalog, qtyKey, false);
  }

  function neutralizeVariantFieldClasses(offer) {
    offer.querySelectorAll('._rsi-quantity-offers-variant-selector').forEach(function (el) {
      el.classList.remove('has-content', 'completed', 'is-next-active', 'is-next-two', '_rsi-modal-fields-item-error');
    });
  }

  function syncAllExistingOffers() {
    var offersRoot = document.querySelector('._rsi-quantity-offers');
    if (!offersRoot) return;
    offersRoot.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (offer) {
      offer.querySelectorAll('._rsi-quantity-offers-variant-selector').forEach(function (selector) {
        syncExistingSelector(selector, offer);
      });
      neutralizeVariantFieldClasses(offer);
    });
  }

  function processAll(forceRefresh) {
    if (processing) return false;
    ensureStyles();

    var offersRoot = document.querySelector('._rsi-quantity-offers');
    if (!offersRoot) return false;

    var selects = offersRoot.querySelectorAll('select[data-offer-num]');
    if (!selects.length) return false;

    processing = true;
    try {
      // Seed only for brand-new rows. Never let PDP stomp form edits.
      var seed = forceRefresh ? readPdpSelection({ persist: false }) : readFormSelectionSeed();
      var offers = offersRoot.querySelectorAll('._rsi-quantity-offers-offer-container');

      offers.forEach(function (offer) {
        offer.classList.add('has-rsi-variant-selectors');
        offer.querySelectorAll('.custom-offer-title').forEach(function (t) {
          t.style.display = 'none';
        });

        offer.querySelectorAll('._rsi-quantity-offers-variant-selector').forEach(function (selector) {
          transformSelector(selector, offer, seed, !!forceRefresh);
        });

        neutralizeVariantFieldClasses(offer);
      });

      if (typeof window._rsiLayoutQuantityOfferVariants === 'function') {
        window._rsiLayoutQuantityOfferVariants();
      }
      if (typeof window._rsiEnsureStickyHeader === 'function') {
        window._rsiEnsureStickyHeader();
      }
      if (typeof window._rsiUpdateOrderSummary === 'function') {
        setTimeout(window._rsiUpdateOrderSummary, 80);
      }
      return true;
    } finally {
      processing = false;
    }
  }

  function schedule(force) {
    clearTimeout(scheduled);
    scheduled = setTimeout(function () {
      processAll(!!force);
    }, 180);
  }

  window._rsiProcessQuantityOfferVariants = processAll;
  window._rsiReadPdpVariantSelection = readPdpSelection;
  window._rsiSyncQuantityOfferVariantInputs = syncAllExistingOffers;

  document.addEventListener(
    'change',
    debounce(function (e) {
      if (!e.target) return;

      // Form Color/Talla changes are authoritative — never re-seed from PDP
      if (e.target.classList && e.target.classList.contains('rsi-variant-select')) {
        var offer = e.target.closest('._rsi-quantity-offers-offer-container');
        if (offer) neutralizeVariantFieldClasses(offer);
        return;
      }

      if (
        e.target.closest('variant-selects') ||
        e.target.closest('.product-form__input') ||
        e.target.closest('.variant__selects-container') ||
        (e.target.matches &&
          e.target.matches('[data-option-name], [name*="Color"], [name*="Talla"], [name*="options"]'))
      ) {
        // Only refresh PDP cache while form is closed
        var formOpen = !!document.querySelector(
          '#_rsi-cod-form-modal._rsi-cod-form-modal-open #_rsi-cod-form-modal-form'
        );
        if (!formOpen) readPdpSelection({ persist: true });
      }
    }, 120),
    true
  );

  document.addEventListener(
    'click',
    debounce(function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('[data-option-name], .variant-option, fieldset label')) return;
      var formOpen = !!document.querySelector(
        '#_rsi-cod-form-modal._rsi-cod-form-modal-open #_rsi-cod-form-modal-form'
      );
      if (formOpen) return;
      setTimeout(function () {
        readPdpSelection({ persist: true });
      }, 30);
      setTimeout(function () {
        readPdpSelection({ persist: true });
      }, 180);
    }, 80),
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (
        !e.target.closest(
          '#rsi_buy_now_button, ._rsi-buy-now-button, ._rsi-buy-now-button-product, [id*="rsi_buy_now"]'
        )
      ) {
        return;
      }
      readPdpSelection({ persist: true });
      window.__rsiFormVariantLocked = false;
      setTimeout(function () {
        processAll(true);
      }, 300);
      setTimeout(function () {
        processAll(false);
      }, 900);
      setTimeout(function () {
        if (typeof window._rsiEnsureStickyHeader === 'function') window._rsiEnsureStickyHeader();
      }, 500);
      setTimeout(function () {
        if (typeof window._rsiEnsureStickyHeader === 'function') window._rsiEnsureStickyHeader();
      }, 1200);
    },
    true
  );

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList') {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;
          if (
            n.classList &&
            (n.classList.contains('rsi-unit-row') ||
              n.classList.contains('rsi-variant-group') ||
              n.classList.contains('_rsi-sticky-header') ||
              n.classList.contains('_rsi-quantity-offers-variants-stack'))
          ) {
            continue;
          }
          if (
            n.id === '_rsi-cod-form-modal' ||
            n.id === 'rsi-cod-form-quantity-offers-hook' ||
            (n.classList && n.classList.contains('_rsi-quantity-offers')) ||
            (n.querySelector &&
              n.querySelector('._rsi-quantity-offers') &&
              !n.querySelector('.rsi-unit-row'))
          ) {
            schedule(false);
            return;
          }
          if (
            n.matches &&
            n.matches('select[data-offer-num]:not([data-rsi-split="1"])')
          ) {
            schedule(false);
            return;
          }
        }
      }
      if (
        m.type === 'attributes' &&
        m.attributeName === 'class' &&
        m.target &&
        m.target.classList &&
        m.target.classList.contains('_rsi-quantity-offers-offer-container')
      ) {
        // Offer switch: debounce heavily — Releasit toggles classes many times per click
        clearTimeout(window.__rsiOfferSwitchTimer);
        window.__rsiOfferSwitchTimer = setTimeout(function () {
          syncAllExistingOffers();
          if (typeof window._rsiUpdateOrderSummary === 'function') {
            window._rsiUpdateOrderSummary();
          }
        }, 320);
        return;
      }
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  function hookModalBus() {
    if (!window._rsiModalBus || window._rsiModalBus.__variantSplitHooked) return;
    window._rsiModalBus.__variantSplitHooked = true;
    var originalOpen = window._rsiModalBus.open.bind(window._rsiModalBus);
    window._rsiModalBus.open = function () {
      // Fresh open: allow PDP seed once until user edits in-form
      window.__rsiFormVariantLocked = false;
      readPdpSelection({ persist: true });
      originalOpen();
      setTimeout(function () {
        processAll(true);
      }, 200);
      setTimeout(function () {
        processAll(false);
      }, 700);
      setTimeout(function () {
        if (typeof window._rsiEnsureStickyHeader === 'function') window._rsiEnsureStickyHeader();
      }, 350);
      setTimeout(function () {
        if (typeof window._rsiEnsureStickyHeader === 'function') window._rsiEnsureStickyHeader();
      }, 1000);
    };
  }
  hookModalBus();
  setInterval(hookModalBus, 1000);

  setInterval(function () {
    var root = document.querySelector('._rsi-quantity-offers');
    if (!root) return;
    root.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(neutralizeVariantFieldClasses);
  }, 700);

  readPdpSelection({ persist: true });
  if (document.querySelector('._rsi-quantity-offers')) schedule(true);
})();
